import Service from "../../AuthService";
const Employee = {
    getEmployee(page) {
        return Service.get("/employee?page="+page);
    },
    showEmployee(id) {
        return Service.get("/employee/" + id);
    },
    updateEmployee(id, data) {
        return Service.put("/employee/" + id, data);
    },
    createEmployee(data) {
        return Service.post("/employee", data);
    },
    deleteEmployee(id) {
        return Service.delete("/employee/" + id);
    },
    getEmployeeAll(){
        return Service.get("/employee-all");
    },
    searchEmployee(data){
        return Service.post("/employee-search",data)
    },
    searchPaymentSalary(data){
        return Service.post("/employee-salary-search",data)
    },
    filterEmployee(page,status) {
        return Service.get("employee-filter?page=" + page +
            "&status=" + status);
    },
    uploadFilePDF(data){
        return Service.post("/employee-upload-file",data);
    },
    validatePassportNumber(citizen_id){
        return Service.get("/validate_passport?citizen_id="+citizen_id);
    },
    approveEmployee(data){
        return Service.post('/update_approve_employee',data);
    },
    validateEmployeeNo(employee_no) {
        return Service.get('/validate_employee_no?employee_no='+employee_no)
    },
    //slip salary
    previewSalaryPDF(data){
        return Service.get("/preview-salary-pdf?week=" +data.week+
            "&date="+data.date+
            "&name="+data.name+
            "&employee_id="+data.employee_no+
            "&department_id="+data.department_id,)
    },
    exportSlipSalaryEmployee(data){
        return Service.get(`DisplaySalaryEmployee?week=${data.week}&month=${data.month}&department=${data.department}&employee_no=${data.employee_no}`)
    },
    exportExpireEmployee(data){
        return Service.get(`ExpireEmployee?type_view=${data.type_view}&department_id=${data.department_id}&date=${data.date}&employee_no=${data.employee_no}&passport_type_id=${data.passport_type_id}`)
    }
};
export default Employee;
